var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showWelcomePage)?_c('welcome-page'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }